export default __webpack_public_path__ + "static/media/ccc945bbf6128efe8c219069cbad4b2c.jpg";